module.exports = __webpack_public_path__ + "img/img_maracana_tour.b7bba80e.png";